export default {
    link_copied_to_clipboard: 'Lien copié dans le presse-papiers !',
    at: 'à',
    open: 'Ouvrir',
    close: 'Proche',
    apply: 'Appliquer',
    cancel: 'Annuler',
    search: 'Chercher',
    cancel_search: 'Annuler la recherche',
    edit_search: 'Modifier la recherche',
    erase: 'Effacer',
    back_to_results: 'Retour aux résultats',
    save: 'Sauver',
    retry: 'Réessayer',
    click_here: 'Cliquez ici',
    copy: 'Copie',
    copied: 'Copié',
    copied_coordinates: 'Coordonnées copiées',
    copy_coordinates: 'Copier les coordonnées',
    copied_address: 'Adresse copiée',
    copy_address: "Copier l'adresse",
    map_context: {
        route_from_here: 'Calculer un itinéraire depuis ici',
        route_to_here: 'Calculer un itinéraire vers ce point',
        find_near_vehicles: 'Trouver les véhicules à proximité',
        vehicles_history: "Voir l'historique des véhicules",
        create_poi: 'Créer un nouveau POI ici'
    },
    invalid_coordinates: "Impossible d'ouvrir cet emplacement",
    open_in_maps: 'Ouvrir dans Google Maps',
    reports: 'Rapports',
    notifications: 'Gestion des notifications',
    notification_management: {
        search_placeholder: 'Rechercher des règles',
        search_scope: 'Où rechercher',
        search_everywhere: 'Rechercher partout',
        search_by_plate: 'Rechercher par immatriculation',
        search_by_tag: 'Rechercher par tag',
        search_by_event_name: "Rechercher par nom d'événement",
        event_filter: 'Filtrer par événement',
        all_events: 'Tous les événements',
        poi_entry: 'Entrée dans un POI',
        poi_exit: "Sortie d'un POI",
        channel_filter: 'Filtrer par canal',
        all_channels: 'Tous les canaux',
        email: 'E-mail',
        sms: 'SMS',
        new_rule: 'Nouvelle règle',
        reset_filters: 'Réinitialiser les filtres',
        all_destinations: 'Toutes les destinations',
        destination_filter: 'Filtrer par destination',
        edit_rule: 'Edit rule',
        clone_rule: 'Dupliquer la règle',
        copy_of: 'Copie de',
        unsaved_changes_title: 'Modifications non enregistrées',
        unsaved_changes_message:
            'Vous avez des modifications non enregistrées. Voulez-vous quitter et les ignorer ?',
        discard_changes: 'Quitter sans enregistrer',
        continue_editing: 'Continuer la modification',
        rule_form_subtitle: 'Configure the event, vehicles and notification channels.',
        rule_details: 'Rule details',
        rule_details_hint: 'Name the rule and choose the event to monitor.',
        rule_name: 'Rule name',
        rule_name_placeholder: 'E.g. Vehicles entering headquarters',
        monitored_event: 'Event to monitor',
        rule_language: 'Langue de la notification',
        language_italian: 'Italien',
        language_english: 'Anglais',
        event_not_supported: 'bientôt disponible',
        event_not_supported_error: 'Sélectionnez un événement pris en charge par l’API.',
        target_vehicles: 'Target vehicles',
        target_vehicles_hint: 'Apply the rule to the fleet or to selected vehicles.',
        whole_fleet: 'Whole fleet',
        whole_fleet_hint: 'The rule applies to every vehicle.',
        specific_vehicles: 'Specific vehicles',
        specific_vehicles_hint: 'Select by tag and/or plate.',
        vehicle_tags: 'Vehicle tags',
        no_vehicle_tags: 'No vehicle tags are available.',
        vehicle_plates: 'Plates',
        select_vehicles: 'Select one or more plates',
        target_and_hint:
            'When tags and plates are both selected, the criteria are combined with AND.',
        event_parameters: 'Event parameters',
        event_parameters_hint: 'Parameters depend on the selected event.',
        pois_to_monitor: 'POIs to monitor',
        select_pois: 'Select one or more POIs',
        poi_categories_to_monitor: 'Catégories de POI à contrôler',
        select_poi_categories: 'Sélectionnez une ou plusieurs catégories de POI',
        stopped_after_hours: 'Notify when the vehicle has been stopped for',
        hours_unit: 'heures',
        hour_unit: 'heure',
        excluded_stop_pois: 'Do not notify stops in the following POIs',
        excluded_stop_poi_categories:
            'Ne pas notifier les arrêts dans les catégories de POI suivantes',
        notify_for_hours: 'Continuer les notifications pendant',
        temperature_threshold: 'Notify when the temperature exceeds',
        low_temperature_threshold: 'Notifier lorsque la température descend sous',
        minimum_notification_interval: 'Minimum interval between two notifications',
        minutes_unit: 'minutes',
        minute_unit: 'minute',
        minimum_duration_hint: 'Durée minimale : :duration',
        required_positive_number: 'Enter a value greater than zero.',
        non_negative_number: 'The value cannot be negative.',
        parameters_to_define: 'The event-specific configuration will be added in the next step.',
        select_event_first: 'Select an event first',
        channels_recipients: 'Channels and recipients',
        channels_recipients_hint: 'Enable at least one channel and specify its recipients.',
        email_recipients_hint: 'Email addresses that will receive the notification.',
        sms_recipients_hint: 'Phone numbers that will receive the notification.',
        add_email_recipient: 'Enter an email address',
        add_sms_recipient: 'Enter a phone number',
        add_recipient: 'Add',
        remove_recipient: 'Remove recipient',
        invalid_email_recipient: 'Enter a valid email address.',
        invalid_phone_recipient: 'Enter a valid phone number.',
        duplicate_recipient: 'This recipient has already been added.',
        required_field: 'Required field.',
        target_required: 'Select at least one tag or plate.',
        channel_required: 'Enable at least one notification channel.',
        recipient_required: 'Enter at least one recipient.',
        views: 'Vues de gestion des notifications',
        event_list: 'Liste des événements',
        category_event_list: 'Liste des événements par catégorie',
        name_event: 'Nom/Événement',
        applied_to: 'Appliquée à',
        main_parameters: 'Paramètres principaux',
        channels: 'Canaux',
        actions: 'Actions',
        no_rules: 'Aucune règle de notification disponible.',
        loading_rules: 'Chargement des règles de notification…',
        load_rules_error: 'Impossible de charger les règles de notification.',
        create_rule_success: 'Règle de notification créée avec succès.',
        create_rule_error: 'Impossible de créer la règle de notification.',
        update_rule_success: 'Règle de notification mise à jour avec succès.',
        update_rule_error: 'Impossible de mettre à jour la règle de notification.',
        delete_rule: 'Supprimer la règle',
        delete_rule_confirmation: 'Voulez-vous supprimer la règle « :name » ?',
        delete_rule_success: 'Règle de notification supprimée avec succès.',
        delete_rule_error: 'Impossible de supprimer la règle de notification.',
        channel_enabled: 'activé',
        channel_disabled: 'désactivé',
        recipient_total: ':count destinataire au total',
        recipients_total: ':count destinataires au total',
        language: 'Langue'
    },
    notification_events: {
        categories: {
            poi: 'POI',
            vehicle_status: 'État du véhicule',
            temperature: 'Température',
            ignition: 'Allumage',
            doors: 'Portes',
            tachograph: 'Tachygraphe'
        },
        events: {
            poi_in: 'Entrée dans un POI',
            poi_out: "Sortie d'un POI",
            vehicle_stationary: 'Véhicule arrêté',
            low_temperature: 'Température sous le seuil',
            high_temperature: 'Température au-dessus du seuil',
            door_open: 'Ouverture de porte',
            poi_entry: 'Entrée dans un POI',
            poi_exit: "Sortie d'un POI",
            vehicle_stopped: 'Véhicule arrêté',
            probe_temperature_threshold: 'Seuil de température de la sonde',
            vehicle_ignition_on: 'Allumage du véhicule',
            vehicle_ignition_off: 'Extinction du véhicule',
            door_opened: 'Ouverture de porte',
            door_closed: 'Fermeture de porte',
            driver_card_inserted: 'Insertion de la carte conducteur'
        }
    },
    tachograph_activities: 'Activités du tachygraphe',
    tachograph_activities_period_hint:
        "Voir l'activité du tachygraphe du véhicule pour cette période :",
    select: 'Sélectionner',
    selected: 'Sélectionné',
    selected_plural: 'Sélectionnés',
    deselect: 'Désélectionner',
    select_multi_vehicles: 'Sélectionnez un ou plusieurs véhicules',
    include: 'Inclure',
    exclude: 'Exclure',
    balanced: 'Équilibré',
    input: 'Entrée',
    output: 'Sortie',
    verified: 'Vérifié',
    save_settings: 'Sauvegarder les paramètres',
    empty_search: 'Aucun résultat trouvé',
    read_more: 'Lire la suite',
    details: 'Détails',
    actual: 'En cours',
    residual_time: 'Temps restant',
    next: 'Prochain',
    previous: 'Précédent',
    menu_open: 'Ouvrir le menu',
    hide: 'Cacher',
    show: 'Montrer',
    none: 'Aucun',
    none_alt: 'Aucune',
    all: 'Tous',
    all_alt: 'Toutes',
    default: 'Défaut',
    settings: 'Paramètres',
    vehicle_list_settings: 'Paramètres de la liste des véhicules',
    reset_settings: 'Réinitialiser les paramètres',
    reset_settings_success: 'Paramètres réinitialisés avec succès',
    settings_saving: 'Enregistrement des paramètres…',
    settings_save_error: "Échec de l'enregistrement des paramètres : modifications annulées",
    multiselect_default_value: {
        singular: 'Valeur sélectionnée:',
        plural: 'Valeurs sélectionnées:'
    },
    available: 'Disponible',
    unavailable: 'Pas disponible',
    not_available: 'Pas disponible',
    not_available_plural: 'Pas disponibles',
    from: 'de',
    to: 'au',
    of: 'de',
    yes: 'Oui',
    no: 'Non',
    minutes: 'Minutes',
    hours: 'Heures',
    hour: 'Heure',
    days: 'Jours',
    day: 'Jour',
    months: 'Mois',
    month: 'Mois',
    years: 'Ans',
    year: 'An',
    days_names: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    days_names_short: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    months_names: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre'
    ],
    months_names_short: [
        'Jan',
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Aoû',
        'Sep',
        'Oct',
        'Nov',
        'Déc'
    ],
    areas: 'Zones',
    area: 'Zone',
    time: 'Temps (min)',
    time_label: 'Temps',
    cost: 'Coût',
    toll_cost: 'Coût du péage',
    km_cost: 'Coût à km',
    hourly_cost: 'Coût horaire',
    working_cost: 'Coût par homme total',
    total_cost: 'Coût total',
    expire_date: "Date d'expiration",
    start_date: 'Date de début',
    recap: 'Résumé',
    start: 'Début',
    starting_point: 'Départ',
    end: 'Fin',
    finish_point: 'Arrivée',
    duration: 'Durée',
    distance: 'Distance',
    daily_distance: 'Km parcourus par jour',
    distance_total: 'Distance totale',
    gps_distance: 'Distance (GPS)',
    distance_gps: 'Km parcourus par jour (GPS)',
    pause: 'Pause',
    segment: 'Trajet',
    start_time: 'Heure de début',
    end_time: 'Heure de fin',
    service_time: 'Temps de service',
    waypoint_load: 'Charge à bord',
    state: 'État',
    driver_statuses: {
        nessuno_stato: 'Aucun état',
        carico: 'Chargé',
        scarico: 'Déchargé',
        aggancio_semirimorchio: 'Attache de la semi-remorque',
        sgancio_semirimorchio: 'Détachement de la semi-remorque',
        rifornimento: 'Ravitaillement'
    },
    violated_plafond: 'Violation de Plafond',
    traffic_delay: 'Retard de circulation',
    company: 'Compagnie',
    address: 'Adresse',
    position: 'Localisation',
    route: 'Itinéraire',
    filter_date: 'Filtrer par date',
    warning: 'Prudence',
    no_warning: 'Sans préavis',
    alerts: 'Avis',
    trucks_with_alerts: 'Véhicules avec avertissements',
    bluetooth_devices: 'Appareils Bluetooth',
    no_bluetooth_devices: 'Aucun appareil Bluetooth trouvé',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    bluetooth_types: {
        temperature_probe: 'Sonde de température',
        door_probe: 'Porte et sonde de température'
    },
    back_to_home: "Retour à l'accueil",
    cerca: 'Chercher',
    search_vehicle: 'Chercher véhicule',
    filter: 'Filtrer',
    filter_label: 'Filtre',
    filters_label: 'Filtres',
    filter_by: 'Filtrer par',
    operations: 'Opérations',
    filter_vehicles: 'Filtrer les véhicules',
    filter_applied: 'Filtre appliqué',
    filter_canceled: 'Filtre annulé avec succès',
    order_by: 'Trier par',
    order: 'Ordre',
    ascending: 'Croissance',
    descending: 'Décroissant',
    value: 'Valeur',
    select_filter: 'Sélectionner un filtre',
    sort_vehicles: 'Trier les véhicules',
    sort_for_alphanumeric: 'Alphabétique',
    sort_for_lastpoint: 'Chronologique',
    sort_for_company: 'Compagnie',
    sort_for_activity: 'Activités',
    company_select: 'Sélectionner entreprise',
    no_companies_founded: 'Aucune entreprise trouvée',
    multicompany: 'Filtre par entreprise',
    no_vehicles_founded: 'Aucun véhicule trouvé',
    print: 'Imprimer',
    export: 'Exporter',
    print_recap: 'Imprimer résumé',
    select_date: 'Sélectionnez une date',
    add: 'Ajouter',
    add_new: 'Ajouter un nouveau',
    delete: 'Supprimer',
    edit: 'Modifier',
    options: 'Options',
    login: 'Veuillez vous connecter',
    logout: 'Déconnexion',
    logout_confirm: 'Êtes-vous sûr de vouloir vous déconnecter?',
    login_button: 'Connexion',
    connect: 'Connexion',
    logged: 'Connecté',
    manage: 'Gérer',
    loading: 'Chargement',
    loading_timeout: 'Erreur de réseau, veuillez recharger la page ou réessayer plus tard',
    go_back: 'Retour',
    select_coordinates: 'Sélectionner les coordonnées',
    other: 'Autre',
    options_general: 'Générales',
    options_language: 'Langue',
    change_interface_language: "Changer la langue de l'interface",
    change_infringment_language: 'Changer la langue des infractions',
    change_timezone: 'Changer le fuseau horaire',
    save_language_settings: 'Sauvegarder les paramètres de langue',
    select_view: 'Sélectionner la vue',
    select_fields_placeholder: 'Sélectionner les champs à afficher',
    selected_field: 'Champ sélectionné',
    selected_fields: 'Champs sélectionnés',
    list: 'Liste',
    table: 'Tableau',
    view_options: 'Options de vue',
    fluid_table: 'Largeur dynamique',
    fluid_table_descr:
        'Étirez le tableau sur toute la largeur disponible, en la répartissant entre les colonnes sélectionnées',
    nearest_city: 'Ville la plus proche',
    no_columns_selected: 'Aucune colonne sélectionnée',
    actions: 'Actions',
    sort_column: 'Trier par cette colonne',
    move_column: 'Déplacer la colonne',
    hide_column: 'Masquer la colonne',
    show_all: 'Tout afficher',
    load_failed_retry: 'Échec du chargement, cliquez pour réessayer',
    hide_all: 'Tout masquer',
    columns_order: 'Ordre des colonnes',
    reset_columns: 'Réinitialiser par défaut',
    vehicle_fields_list:
        'Quelles informations souhaitez-vous voir apparaître pour chaque véhicule? (Max 3)',
    vehicle_fields_list_warning:
        "Attention : le champ ne sera pas affiché s'il n'est pas disponible pour le véhicule.",
    vehicle_identification:
        'Comment voulez-vous que le véhicule soit identifié dans la liste principale?',
    apply_to_marker: "Ce paramètre s'applique également aux véhicules présents sur la carte",
    element_icon_section: "Icône de l'élément",
    element_title_section: "Titre de l'élément",
    element_fields_list_section: "Liste des champs de l'élément",
    element_icon_description: "Sélectionnez l'icône à afficher pour l'élément",
    element_icon: 'Icône',
    element_icon_color: "Couleur de l'icône",
    options_map: 'Options carte',
    vehicles_clustering: 'Groupe de véhicules',
    vehicles_clustering_warning:
        'La mise à jour de ce paramètre nécessite le rechargement de la page.',
    options_marker: 'Options de marqueur',
    size: 'Taille',
    font_size: 'Taille de texte',
    font_color: 'Couleur de texte',
    background_color: 'Couleur de fond',
    opacity: 'Opacité',
    color: 'Couleur',
    small: 'Petit',
    medium: 'Moyen',
    large: 'Grand',
    additional_info: 'Informations supplémentaires',
    add_marker_data: 'Sélectionner les données à afficher',
    remove: 'Supprimer',
    move_up: 'Monter',
    move_down: 'Descendre',
    analysis_options: 'Analyse des itinéraires',
    options_chart: 'Options graphique',
    options_timeline: 'Options timeline',
    hide_timeline: 'Cacher timeline',
    bind_colors: 'Associer les couleurs',

    // Others
    map: 'Carte',
    silica: 'Silica',
    google: 'Google',
    google_satellite: 'Satellite Google',
    sandbox: 'Sandbox',
    silkysand: 'Silkysand',
    gravelpit: 'Gravelpit',
    open_street_maps: 'Open Street Maps',
    arcgis_satellite: 'Satellite Arcgis',
    traffic: 'Trafic',
    traffic_anomalies: 'Accidents et anomalies',
    heavy_vehicles_ban: 'Interdictions de véhicules lourds',
    driver: 'Conducteur',
    no_driver: 'Sans conducteur',
    drivers: 'Conducteurs',
    driver_card: 'Carte conducteur',
    name: 'Nom',
    surname: 'Prénom',
    driver_activity: 'Activité conducteur',
    driver_status: 'Statut conducteur',
    drivers_statuses: 'Statuts conducteur',
    activity_type: "Type d'activité",
    activity: 'Activité',
    no_activity: 'Aucune activité',
    driver_at_rest: 'Conducteur en repos',
    driver_available: 'Conducteur disponible',
    driver_at_work: 'Conducteur au travail',
    driver_driving: 'Conducteur en conduite',
    inactive_vehicle: 'Véhicule inactif',
    last_driver_detected: 'Dernier conducteur détecté',
    rest: 'Repos',
    work: 'Travail',
    driving: 'Conduite',
    availability: 'Disponibilité',
    codriving: 'Co-conduite',
    codriver: 'Co-conducteur',
    break: 'Pause de session',
    daily_rest: 'Repos quotidien',
    violation: 'Violation',
    to_begin_within: 'A commencer dans',
    to_end_within: 'A terminer dans',
    after_total_time_travel: 'Après un voyage total de',
    after_total_distance_travel: 'Après un voyage total de',
    residual_commitment_type: "Type d'engagement restant",
    residual_commitment: 'Engagement restant',
    commitment_hours: "Heures d'engagement",
    commitment_hours_description:
        "Trouver tous les véhicules dont les conducteurs ont un engagement résiduel plus élevé qu'indiqué",
    driver_plafond: 'Plafond conducteur',
    residual_driving: 'Conduite restant',
    residual_bonuses: 'Bonus restant',
    consider_bonuses: 'Le temps est calculé en tenant compte des bonus résiduel',
    current_activity: 'Activité actuelle',
    next_activity: 'Prochaine activité',
    view_plafond_detail: 'Voir les détails du plafond',
    view_infringements: 'Voir les infractions',
    view_tachograph_activities: 'Voir les activités du tachygraphe',
    card: 'Carte',
    driver_change: 'Changement de conducteur',
    shared_links: 'Lien partagé',
    gf: 'POI détecté',
    analyze: 'Analyser',
    plan: 'Planifier',
    vehicle: 'Véhicule',
    vehicles: 'Véhicules',
    vehicle_info: 'Informations sur le véhicule',
    vehicle_type: 'Type de véhicule',
    vehicle_body: 'Corps véhicule',
    truck_status: 'Statut du véhicule',
    brand: 'Marque',
    model: 'Modèle',
    no_card: 'Carte non inséré',
    no_card_driving: 'Carte non inséré en conduite',
    speed: 'Vitesse',
    tacho_speed: 'Vitesse (tachygraphe)',
    vehicle_hooked: 'Véhicule attaché',
    truck_hooked_text: 'Ce véhicule est attaché au suivant remorque: ',
    trailer_hooked_text: 'Ce remorque est attaché au suivant véhicule: ',
    no_driver_rfid_info:
        "La carte du conducteur n'est pas enregistrée dans la liste des conducteurs",
    gps_speed: 'Vitesse (GPS)',
    level: 'Niveau',
    battery: 'Batterie',
    low_battery_level: 'Niveau de batterie faible',
    fuel: 'Carburant',
    fuel_level: 'Niveau de carburant',
    low_fuel_level: 'Niveau de carburant faible',
    consumption: 'Consommation',
    consumptions: 'Consommation',
    fuel_consumption: 'Consommation de carburant',
    fuel_avg_consumption: 'Consommation quotidienne moyenne de carburant',
    altitude: 'Altitude',
    weight: 'Poids',
    lastpoint_weight: 'Poids (dernier point)',
    vehicle_weight: 'Poids (t)',
    vehicle_length: 'Longueur (m)',
    vehicle_width: 'Largeur (m)',
    vehicle_height: 'Hauteur (m)',
    odometer: 'Odomètre',
    odometer_tacho: 'Odomètre (tachygraphe)',
    odometer_gps: 'Odomètre (GPS)',
    gps_odometer: 'Odomètre (GPS)',
    last_point: 'Dernier point',
    moving: 'En mouvement',
    stopped: 'Arrêté',
    engine_on: 'Moteur en marche',
    ignition: 'Tableau de bord',
    engine_off: 'Moteur éteint',
    engine_on_off: 'Allumage du moteur',
    ignition_on: 'Tableau activé',
    ignition_off: 'Tableau éteint',
    device: 'Dispositif',
    plate: 'Plaque',
    chassis: 'Châssis',
    status: 'Statut',
    custom_id: 'Nom personnalisé',
    heading: 'Direction',
    rpm_engine: 'Régime moteur',
    pto_active: 'PTO actif',
    pto_state: 'État PTO',
    device_timestamp: 'Timestamp',
    info: 'Info',
    solar_day_report: 'Rapport de jour solaire',
    telemetry: 'Télémétrie',
    parameters: 'Paramètres',
    engine_coolant_temp: 'Température du moteur',
    engine_rpm: 'Régime moteur',
    dallas_temp_1: 'Température 1',
    dallas_temp_2: 'Température 2',
    dallas_temp_id_1: 'ID Température 1',
    dallas_temp_id_2: 'ID Température 2',
    digital_input_1: 'Entrée digitale 1',
    digital_input_2: 'Entrée digitale 2',
    digital_input_3: 'Entrée digitale 3',
    digital_input_4: 'Entrée digitale 4',
    digital_input_5: 'Entrée digitale 5',
    battery_level: 'Niveau de batterie',
    adblue_liters: 'Litres Adblue',
    adblue_level: 'Niveau Adblue',
    gnss_status: 'Statut GNSS',
    gnss_status_values: [
        'Off',
        'On, sans GPS',
        'On, sans satellites',
        'On, avec satellites',
        'On, en sleep mode',
        'Mode de protection'
    ],
    gnss_off: 'GNSS off',
    gnss_on_fix: 'GNSS on, avec satellites',
    gnss_on_without_fix: 'GNSS on, sans satellites',
    gnss_on_sleep: 'GNSS on, en sleep mode',
    gnss_on_protection: 'GNSS on, protection mode',
    gsm_signal: 'Signal GSM',
    tacho_source: 'Source du tachygraphe',
    external_voltage: 'Alimentation',
    tacho_overspeed: 'Tachygraphe de survitesse',
    no_points_title: 'Dernière activité depuis plus de 24 heures',
    no_points: "Ce véhicule n'a pas envoyé de points depuis plus de 24 heures",
    clutch: 'Embrayage',
    clutch_switch: "Interrupteur d'embrayage",
    brake_pedal: 'Pédale de frein',
    accelerator_pedal: 'Pédale d’accélérateur',
    pedal_released: 'Pédale relâchée',
    pedal_pressed: 'Pédale enfoncée',
    data_mode: 'Mode de données',
    home_stop: 'Home stop',
    home_moving: 'Home moving',
    roaming_stop: 'Roaming stop',
    roaming_moving: 'Roaming moving',
    unknown_stop: 'Unknown stop',
    unknown_moving: 'Unknown moving',
    engine_coolant_temperature: 'Température du liquide de refroidissement',
    engine_temperature: 'Température du moteur',
    cruise_control_active: 'Cruise control actif',
    adblue_off: 'Adblue off',
    adblue_red: 'Adblue red',
    adblue_yellow: 'Adblue yellow',
    adblue_info: 'Adblue info',
    charger_notconnected: 'Chargeur non connecté',
    charger_connected: 'Chargeur connecté',
    tacho_unknown: 'Inconnu',
    tacho_kline: 'K-Line',
    tacho_allcan: 'BUS-CAN',
    tacho_can: 'BUS-CAN',
    tacho_fms: 'FMS',
    lock_command: 'Commande de verrouillage',
    vehicle_not_found: "Le véhicule auquel vous essayez d'accéder n'est pas disponible",
    vehicle_with_lock_commands: 'Véhicule avec commandes de verrouillage',
    lock: 'Verrouiller',
    unlock: 'Déverrouiller',
    send: 'Envoyer',
    command_sent: 'Commande envoyée',
    turn_on: 'Allumer',
    turned_on: 'Allumé',
    turn_off: 'Éteindre',
    turned_off: 'Éteint',
    confirm_send_command: 'Confirmez-vous que vous voulez envoyer la commande ?',
    temperature: {
        title: 'Sondes de température',
        probe: ['Sonde 1', 'Sonde 2', 'Sonde 3', 'Sonde 4', 'Sonde 5', 'Sonde 6']
    },
    no_power_supply: "Pas d'alimentation",
    no_gps: 'Pas de GPS',
    tacho_clock_from_updated_error: "Erreur de synchronisation de l'horloge du tachygraphe",
    tacho_clock_from_device_error:
        "Erreur de synchronisation entre le tachygraphe et l'unité de contrôle",
    device_timestamp_error: "Erreur de date de l'unité de contrôle",
    select_color_mode: 'Sélectionner le mode de couleur',
    light_mode: 'Mode clair',
    dark_mode: 'Mode sombre',
    color_blind_mode: 'Mode daltonien',
    color_blind_dark_mode: 'Mode sombre daltonien',
    authorized: 'Autorisé',
    logged_out: 'Déconnecté',
    last_hooked_trailer: 'Dernière remorque accrochée',
    geofleet: {
        mainpanel: {
            pinned_vehicles: 'Véhicules en évidence',
            search_trucks_title: 'Rechercher des véhicules',
            search_trucks_tags_title: 'Tag associées',
            search_trucks_status_title: 'Activité du véhicule',
            search_trucks_driver_status_title: 'Activité conducteur',
            search_near_trucks_title: 'Rechercher des véhicules à proximité'
        },
        detailspanel: {
            bind_vehicle: 'Associer véhicule',
            add_new_tag: 'Ajouter comme un nouveau tag',
            select_new_tag: 'Sélectionner ou rechercher un tag',
            binded_tags: 'Tag associé',
            binded_tag: 'Tags associés'
        },
        analyzer: {
            vehicle_activity_analisys: "Analyse de l'activité des véhicules",
            timeline_separator: 'Regroupement par',
            loading_error: "Une erreur s'est produite lors du chargement des données"
        },
        search_resources: {
            title: 'Rechercher des ressources',
            description:
                'Trouvez les stations-service, les parkings et les zones accessibles les plus proches de votre véhicule.'
        }
    },
    analisys: {
        title: 'Analyse des itinéraires',
        select_telemetries: "Sélectionner la télémétrie à afficher dans l'analyse de l'itinéraire",
        select_telemetries_description:
            'Il est possible de sélectionner un maximum de 4 télémétries à afficher',
        chart_settings: 'Paramètres du graphique',
        map_settings: 'Paramètres de la carte',
        select_telemetries_map: 'Sélectionnez les télémétries à afficher sur la carte',
        select_telemetries_map_description:
            'Ces télémétries sont affichées dans la popup de chaque point du trajet',
        accumulated_data_hint:
            'Lorsquʼils sont activés, chacun de ces paramètres cumule sa valeur depuis le début du trajet jusquʼau point sélectionné',
        chart_groups: {
            movement_data: 'Données sur les mouvements',
            engine_data: 'Données du moteur',
            vehicle_data: 'Données du véhicule',
            sensors_data: 'Données des capteurs',
            driver_data: 'Données sur le conducteur',
            fuel_data: 'Données sur les carburants',
            accumulated_data: 'Données cumulées'
        },
        no_data: 'Aucune donnée disponible',
        no_data_description:
            "Il n'y a aucune donnée d'itinéraire à afficher pour ce véhicule ou pour la période sélectionnée",
        no_data_contact_support: "Contactez le service client pour plus d'informations",
        stop_vehicle_minutes_separator: 'Temps minimum de pause',
        stopped_vehicle: 'Véhicule en pause'
    },
    planner: {
        user_config: 'Configurations utilisateur',
        no_user_config: "Il n'y a aucune configuration utilisateur à afficher",
        freight_access: 'Accès aux chargements de lots',
        vehicle_actual_position: 'Position du véhicule actuel',
        plan_route: "Planifier l'itinéraire",
        select_on_map: 'Sélectionner un point sur la carte',
        select_on_map_option: 'Sélectionner sur la carte',
        fill_route_info: "Remplissez les informations de l'itinéraire",
        fill_resources: 'Sélectionner le point à ajouter comme arrêt',
        fill_waypoints: 'Sélectionner les étapes',
        load_breaks: 'Charger les pauses',
        load_alternative_routes: 'Charger les itinéraires alternatifs',
        savedroutes: {
            my_routes: 'Mes itinérarires',
            saved_routes: 'Itinéraires enregistrés',
            no_saved_routes: "Vous n'avez pas encore enregistré aucune itinéraire",
            success_saved_route: 'Votre chemin a été sauvé avec succès',
            error_saved_route: "Un erreur s'est produite pendant l'enregistrement de l'itinéraire",
            success_deleted_route: 'Votre itinéraire a été éliminé avec succès',
            error_deleted_route: "Un erreur s'est produite pendant l'élimination de l'itinéraire"
        },
        resources: {
            area_search: 'Rechercher dans le rayon de',
            station_services: 'Inclus ces services',
            parking_services: 'Services de stationnement',
            select_rating: 'Sélectionner la notation',
            select_security: 'Sélectionner la sécurité',
            empty_search: "La recherche n'a trouvé aucun élément à montrer",
            delivery_nation: 'Pays de livraison',
            fai_featured: 'Conventionné Lumesia',
            self_service: 'Self Service',
            served: 'Servi',
            total_parking_spots: 'Nombre total de siéges',
            rating: 'Versement',
            reviews: 'Commentaires',
            security: 'Sécurité',
            price_per_night: 'Prix par nuit'
        },
        emissions_labels: 'Émissions',
        emissions: {
            fuelconsumption: 'Consommation de carburant',
            hydrocarbons: 'Hydrocarbures',
            methane: 'Méthane',
            hydrocarbonsexceptmethane: 'Hydrocarbures sauf méthane',
            carbonmonoxide: 'Monoxyde de carbone',
            carbondioxide: 'Gaz carbonique',
            fossilcarbondioxide: 'Dioxyde de carbone fossile',
            sulphurdioxide: 'Dioxyde de soufre',
            nitrogenoxides: "Oxydes d'azote",
            nitrogendioxide: "Dioxyde d'azote",
            nitrousoxide: "Protoxyde d'azote",
            ammonia: 'Ammoniac',
            benzene: 'Benzène',
            particles: 'Particules',
            numberofparticles: 'Nombre de particules'
        },
        plafond_configuration: {
            title: 'Configuration plafond',
            driving_time_regulation: 'Temps de conduite',
            last_time_the_driver_worked: 'Dernière activité du conducteur',
            eu_driving_time_regulation_for_single_day: 'Seule journée',
            eu_driving_time_regulation_for_single_long_day: 'Seule journée (avec des bonus)',
            eu_driving_time_regulation_for_multiple_day: 'Plus de jours',
            eu_driving_time_regulation_for_team_and_multiple_day: 'Plus de jours (avec équipage)',
            accumulated_driving_time_since_lastbreak: 'Heures de conduite depuis la dernière pause',
            accumulated_driving_time_since_lastdailyrest:
                'Heures de conduite depuis le dernier repos quotidien',
            accumulated_travel_time_since_lastdailyrest:
                'Heures de voyage depuis le dernier repos quotidien'
        },
        set_route: "Configurer l'itinéraire",
        select_profile: 'Choisir un profil',
        select_co2_class: "Sélectionner la classe d'émission",
        class: 'Classe',
        billed_roads: 'Routes à péage',
        waypointevent: 'ètape',
        waypoints_label: 'Étapes',
        add_waypoint: 'Ajouter étape',
        delete_waypoint: 'Supprimer étape',
        select_waypoint: "Sélectionner l'étape",
        select_resource: 'Sélectionner le point à ajouter comme arrêt',
        last_waypoint: 'Dernière étape',
        waypoints_check: 'Il y a des étapes à terminer',
        waypoints_required: 'Au moins 2 étapes sont nécessaires',
        countryevent: 'état',
        tollevent: 'Poste de péage',
        event: 'Arrêt',
        alpega: 'Alpega',
        alpega_login: 'Login Alpega',
        alpega_searches: 'Recherches Alpega',
        timocom: 'Timocom',
        pickup: 'Retrait',
        delivery: 'Livraison',
        extimated_cost: 'Coût estimé',
        calculate_route: "Calculer l'itinéraire",
        calculate_isocrona: "Calculer l'isochrone",
        complete_step_2: "Terminez l'étape 2",
        reset_route: 'Nouveau itinéraire',
        route_error: "Un erreur s'est produite pendant le calcul de l'itinéraire",
        edit_route: 'Éditer itinéraire',
        save_route: 'Enregistrer le itinéraire',
        delete_route: "Supprimer l'itinéraire",
        route_name: "Nom de l'itinéraire",
        override_route: "Écraser l'itinéraire",
        save_as_new_route: 'Sauver un nouveau itinéraire',
        calculate_route_for: "Calculer l'itinéraire pour",
        ptvexport: 'Exporter en PTV Navigator',
        isocrona: 'Zones accessibles',
        reset_isocrona: 'Réinitialisation zones accessibles',
        search_location: 'Chercher localité',
        search_station: 'Trouver distributeur',
        search_parking: 'Trouver parking',
        search_poi: 'Cherchez POI',
        include_plafond: "Inclure le plafond du conducteur dans le calcul de l'itinéraire",
        include_plafond_near_vehicles:
            "Trouvez des véhicules avec des chauffeurs avec suffisamment d'efforts restants pour se rendre à l'endroit que vous recherchez",
        violated_plafond: "L'itinéraire sélectionné dépasse le plafond du conducteur"
    },
    sharedlinks: {
        back_to_links: 'Retour aux links',
        create_link: 'Créer des links',
        update_link: 'Mettre à jour le link',
        edit_link: 'Modifier le link',
        update_link_expire_date: "Mettre à jour la date d'expiration",
        delete_link: 'Supprimer le link',
        delete_link_confirm: 'Supprimer le link sélectionné?',
        all_your_shared_links: 'Tous vos links partagés',
        no_shared_links: "Vous n'avez pas encore partagé de véhicule",
        vehicles_link: 'Links pour les véhicules',
        select_share_vehicles: 'Sélectionner des véhicules à partager',
        select_start_expire_date: "Sélectionner la date de démarrage et d'expiration",
        created_link_error: 'Erreur pendant la création du link',
        created_link_success: 'Link créé avec succès',
        updated_link_error: 'Erreur lors de la mise à jour du link',
        updated_link_success: 'Link mis à jour réussi',
        service_description: 'Partager ce link pour montrer le suivi des véhicules sélectionnés',
        link_preview: 'Aperçu du link',
        share_single_vehicle: 'Partagez la position de ce véhicule',
        track_vehicle_position: 'Tracer la position des véhicules sélectionnés',
        start_date_warning: 'La date de début ne peut pas être modifiée',
        start_date_condition:
            'Si vous souhaitez modifier la date de début, vous devez créer un nouveau link',
        expire_date_description:
            "Indiquer une date d'expiration, au-delà de laquelle ce link ne sera plus disponible",
        start_expire_date_description:
            "Indiquer une date initiale, à partir de laquelle ce link sera disponible, et une date d'expiration, au-delà de laquelle ce link ne sera plus disponible"
    },
    viewsharedlink: {
        invalid_date_range:
            "L'intervalle de dates que vous avez sélectionnées n'est pas valable pour ce link",
        too_early_link: "Le link auquel vous essayez d'accéder n'est pas encore disponible",
        too_late_link: "Le link auquel vous essayez d'accéder n'existe plus",
        show_route: "Voir l'itinéraire"
    },
    tags: {
        manage_tags: 'Gérer les tags',
        add_tag: 'Ajouter un tag',
        add_tag_placeholder: 'Ajouter un nouveau tag',
        add_tag_error: "Erreur lors de l'ajout du tag",
        add_tag_success: 'Tag ajouté avec succès',
        delete_tag: 'Supprimer le tag',
        delete_tag_confirm: 'Supprimer le tag sélectionné?',
        delete_tag_error: 'Erreur lors de la suppression du tag',
        delete_tag_success: 'Tag supprimé avec succès',
        update_tag: 'Mettre à jour le tag',
        update_tag_error: 'Erreur lors de la mise à jour du tag',
        update_tag_success: 'Tag mis à jour avec succès',
        all_your_tags: 'Tous vos tags',
        no_tags: "Vous n'avez pas encore de tags",
        tag_name: 'Nom du tag'
    },
    manage_poi: {
        title: 'Gérer les POI',
        your_pois: 'Vos POI',
        add_poi: 'Ajouter un POI',
        no_pois: "Vous n'avez pas encore de POI",
        fields: {
            name: 'Nom',
            type: 'Type',
            color: 'Couleur',
            note: 'Note',
            address: 'Adresse',
            latitude: 'Latitude',
            longitude: 'Longitude',
            radius: 'Rayon',
            radius_description:
                'Pour activer le geofencing, définissez une valeur supérieure à zéro.',
            area_type: 'Type de zone',
            area_type_circle: 'Cercle (centre + rayon)',
            area_type_polygon: 'Polygone',
            polygon_description:
                'Dessinez un polygone sur la carte pour définir la zone de géorepérage.'
        },
        types_poi: {
            all: 'Tous',
            headquarter: 'Siège',
            truck_washes: 'Nettoyage de camion',
            blacklist: 'Liste noire',
            end_of_the_line: 'Fin de ligne',
            customers: 'Clients',
            stops: 'Stops',
            suppliers: 'Fournisseurs',
            interports: 'Interports',
            markets: 'Marchés',
            large_square: 'Grand carré',
            poi_distributors: 'POI Distributeur',
            poi_workshops: 'POI Atelier',
            harbors: 'Ports',
            restaurants: 'Restaurants',
            stations: 'Stations'
        },
        alert_types: {
            in: 'Entrée',
            out: 'Sortie',
            both: 'Entrée et Sortie'
        },
        notifications: {
            enabled: 'Notifications activées',
            disabled: 'Notifications désactivées',
            add_email: 'Ajouter un email',
            settings_title: 'Notifications POI',
            email_addresses: 'Configurez ici les emails à notifier',
            insert: 'Insérer un email'
        },
        messages: {
            add_poi_error: 'Erreur lors de la création du POI',
            add_poi_success: 'POI créé avec succès',
            update_poi_error: 'Erreur lors de la mise à jour du POI',
            update_poi_success: 'POI mis à jour avec succès',
            delete_poi_error: 'Erreur lors de la suppression du POI',
            delete_poi_success: 'POI supprimé avec succès',
            delete_poi_confirm: 'Supprimer le POI sélectionné?',
            create_poi_notification_success: 'Notifiche POI créées avec succès',
            update_poi_notification_success: 'Notifiche POI mises à jour avec succès',
            create_poi_notification_error: 'Erreur lors de la création des notifications POI',
            update_poi_notification_error: 'Erreur lors de la mise à jour des notifications POI',
            delete_poi_notification_error: 'Erreur lors de la suppression des notifications POI',
            delete_poi_notification_success: 'Notifiche POI supprimées avec succès',
            delete_poi_notification_confirm: 'Supprimer les notifications du POI sélectionné?',
            add_emails_success: 'Emails ajoutés avec succès',
            add_emails_error: "Erreur lors de l'ajout des emails",
            invalid_polygon:
                "Le polygone dessiné n'est pas valide. Veuillez sélectionner au moins 3 points."
        },
        categories: {
            title: 'Catégories de POI',
            subtitle: 'Gérez les catégories de vos POI',
            description: 'Description',
            color: 'Couleur',
            add_category: 'Ajouter une catégorie',
            add_category_placeholder: 'Saisissez le nom de la catégorie',
            icon: 'Icône',
            cancel: 'Annuler',
            update_category: 'Mettre à jour la catégorie',
            choose_icon: 'Choisissez une icône',
            no_icons: 'Aucune icône disponible',
            search_icon: 'Rechercher une icône par nom ou code',
            actions: 'Actions',
            scope: 'Type'
        }
    },
    vehicles_cross: {
        title: 'Passages des véhicules',
        fields: {
            address: 'Adresse',
            radius: 'Rayon',
            time_interval: 'Intervalle de temps',
            time_interval_description: "L'intervalle de temps maximum est de 24 heures"
        },
        messages: {
            max_time_interval: "L'intervalle de temps maximum est de 24 heures",
            error_searching: 'Erreur lors de la recherche des passages des véhicules',
            searching: 'Recherche...',
            long_loading: 'La recherche peut prendre un certain temps, veuillez patienter',
            no_vehicles_cross: 'Aucun véhicule trouvé'
        }
    },
    plafonds: {
        session: 'Pause de session',
        break: 'Pause',
        drive_occurring: 'Une Période de Conduite est en cours:',
        drive_max_label: 'Temps de conduite maximum',
        drive_max_value: '4h 30m',
        drive_done: 'Conduite effectuée',
        session_title: 'Informations sur la Pause Fractionnée',
        session_tooltip: "Il est possible d'effectuer une Pause Fractionnée",
        session_done: "Une pause d'au moins 15 minutes a été détectée.",
        session_info: "Première partie d'une Pause Fractionnée déjà effectuée",
        session_descr:
            "Nous rappelons que selon les réglementations en vigueur, il est possible de faire une pause de 15'+30' ou de 15'+15'+15' (en fonction du type de transport effectué).",
        session_choice:
            'Transport de marchandises et de passagers: il est possible de faire une pause de 30 minutes au moins. Service occasionnel de passagers: la pause de 45 minutes consécutives peut être remplacée par deux pauses de 15 minutes au moins chacune.',
        brake_start: 'Début de la pause',
        brake_done: 'Pause effectuée',
        daily: 'Quotidienne',
        weekly: 'Hebdomadaire',
        driver_in_drive: 'Heures de conduite quotidiennes',
        driver_in_rest: 'Repos résiduel',
        driver_in_work: 'Travail',
        driver_in_available: 'Disponibilité',
        driver_in_availability: 'Disponibilité',
        current_activity: 'Activité actuelle',
        mini_plafond: 'Mini-Plafond',
        last_update: 'Dernière mise à jour',
        panel_title: 'Panneau Plafond',
        residual_commitment: 'Engagement résiduel',
        daily_driving: 'Conduite quotidienne',
        driving_to_next_break: 'Conduite jusqu’à la prochaine pause',
        weekly_guide: 'Guide hebdomadaire',
        biweekly_guide: 'Guide bihebdomadaire',
        last_rest: 'Dernier repos hebdomadaire pris',
        minimal_duration_next: 'Durée minimale suivante',
        top_start_until: 'Pour commencer par',
        reduced_weekly_rest: 'Repos hebdomadaires réduits à compenser',
        time_to_compensate: 'Temps pour compenser',
        time_to_compensate_until: 'Pour être compensé par',
        footer_message: '* le temps est calculé en considérant les bonus résiduels',
        driver_in_block: 'Plafond du conducteur épuisé'
    },
    error_pages: {
        error_403: {
            title: 'Erreur 403',
            description:
                "Cher client, nous vous informons que votre compte utilisateur n'est pas configuré pour accéder à ce service. Pour recevoir des informations sur ce service",
            retry_login: "Réessayer l'accès",
            contact_us: 'Contactez-nous'
        }
    },
    ptv: {
        maxpermittedweight: 'Poids lourd',
        minpermittedweight: 'Poids minimum',
        zonename: 'Zone',
        unauthorizedtype: 'Code non autorisé',
        maxemissionstandardeu: "Classe d'émission",
        fueltype: 'Type de carburant',
        loadtype: 'Type de transport',
        opening: 'Monter',
        maxheight: 'hauteur maximum',
        maxweight: 'Poids lourd',
        maxwidth: 'Largeur maximale',
        maxlength: 'Longueur maximale',
        absolutespeed: 'Vitesse',
        hazardoustowaters:
            "Interdiction des véhicules transportant des marchandises dangereuses pour l'eau",
        hazardousgoods: 'Interdiction des véhicules transportant des marchandises dangereuses',
        combustibles: 'Interdiction des véhicules transportant du carburant',
        maxaxleload: 'Poids maximum sur les essieux',
        totalpermittedweight: 'Poids lourd',
        tunnelrestriction: 'Code de restriction de tunnelage',
        kingpintorearaxle: "Distance du pivot d'attelage à l'essieu",
        numberofaxles: "Nombre d'axes",
        length: 'Tronçon',
        delay: 'Retard',
        message: {
            text: 'Message'
        }
    },
    options_interface: 'Interface des options',
    company_filters: {
        branches: 'Branches',
        sectors: 'Secteurs'
    },
    freight_exchange: {
        title: 'Recherche de bourses de fret',
        golia_exchange_sync: 'Synchroniser avec Golia Exchange',
        search_here: 'Rechercher dans la zone affichée',
        zoom_to_search: 'Zoom sur la zone affichée',
        filters: 'Filtres',
        spots: 'Places',
        offers: 'Offres',
        no_offers: 'Aucune offre disponible',
        loading: 'Chargement',
        unloading: 'Déchargement',
        clear_offers: 'Effacer toutes les offres',
        fields: {
            vehicle_type: 'Type de véhicule',
            vehicle_size: 'Taille du véhicule',
            weight_range_from: 'Poids minimum',
            weight_range_to: 'Poids maximum',
            date_range: 'Date de début et de fin',
            destination: 'Destination',
            destination_radius: 'Rayon autour de la destination',
            apply: 'Enregistrer la recherche',
            reset: 'Réinitialiser la recherche'
        },
        popup_key: {
            company: 'Entreprise',
            vehicle: 'Type de véhicule',
            vehicle_size: 'Taille du véhicule',
            required_truck_bodies: 'Corps de camion requis',
            distance: 'Distance',
            pickup: 'Enlèvement',
            delivery: 'Livraison',
            price: 'Prix',
            open_in_golia_exchange: 'Ouvrir dans Golia Exchange'
        },
        vehicle_type: {
            curtainside: 'Rideau latéral',
            cooler: 'Frigorifique',
            standard_tent: 'Bâche standard',
            box: 'Fourgon',
            open_box: 'Fourgon ouvert',
            isotherm: 'Isotherme',
            meathanger: 'Meathanger',
            food_tanker: 'Citerne alimentaire',
            tanker: 'Citerne',
            other: 'Autre',
            car_transporter: 'Porte-voitures',
            dump_truck: 'Camion benne',
            petroleum_tanker: 'Citerne à pétrole',
            chemical_tanker: 'Citerne chimique',
            gas_tanker: 'Citerne à gaz',
            silos: 'Silos',
            mega: 'Mega',
            coilmulde: 'Coilmulde',
            log_trailer: 'Remorque à grumes',
            platform_trailer: 'Plateforme',
            hook_truck: 'Camion à crochet',
            low_loader: 'Surbaissé',
            truck: 'Camion',
            swap_body_system: 'Système de caisses mobiles',
            '20_standard': '20 standard',
            '40_standard': '40 standard',
            '45_standard': '45 standard',
            joloda: 'Joloda',
            bde: 'BDE',
            walkingfloor: 'Walkingfloor',
            tank_body_20: 'Citerne 20',
            tank_body_40: 'Citerne 40',
            jumbo: 'Jumbo'
        },
        vehicle_size: {
            solo: 'Véhicule solo',
            lorry: 'Camion',
            double_trailer: 'Double remorque',
            any_size: 'Toute taille',
            bus: 'Autobus'
        }
    },
    settings_section: {
        address: {
            address_settings: 'Address settings',
            available_elements: 'Available elements',
            address_composition: 'Address composition',
            drag_and_reorder_items: 'Drag and reorder items',
            preview: 'Preview',
            click_to_fetch:
                'Click any point to fetch reverse geocoding and preview the configured output.',
            coordinates: 'Coordinates',
            result: 'Result',
            info_preview:
                'Green pills represent fields mapped for the selected point, red pills represent fields not mapped. Hover a pill to highlight the matching part in the result.',
            elements: {
                city: 'City',
                country: 'Country',
                country_code: 'Country code',
                county: 'County',
                hamlet: 'Hamlet',
                municipality: 'Municipality',
                postcode: 'Postcode',
                road: 'Road',
                state: 'State',
                suburb: 'Suburb',
                town: 'Town',
                village: 'Village'
            }
        },
        map: {
            additional_data: {
                driver_full_name: 'Nom complet du conducteur',
                custom_code: 'Code personnalisé'
            }
        }
    }
}
